import { render, staticRenderFns } from "./LiveSearch.vue?vue&type=template&id=2d36b8b8&"
import script from "./LiveSearch.vue?vue&type=script&lang=js&"
export * from "./LiveSearch.vue?vue&type=script&lang=js&"
import style0 from "./LiveSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports